export default "__VITE_ASSET__CEiueuHo__"